import { render, staticRenderFns } from "./FormPerguntasFrequentes.vue?vue&type=template&id=302b6310&scoped=true&"
import script from "./FormPerguntasFrequentes.vue?vue&type=script&lang=js&"
export * from "./FormPerguntasFrequentes.vue?vue&type=script&lang=js&"
import style0 from "./FormPerguntasFrequentes.vue?vue&type=style&index=0&id=302b6310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302b6310",
  null
  
)

export default component.exports